import { PageLoader, PageLoaderProps } from 'ia-react-core';
import React, { FC } from 'react';

export interface CustomPageLoaderProps extends PageLoaderProps {
}

const CustomPageLoader: FC<CustomPageLoaderProps> = ({ loader, ...props }) => (
  <PageLoader {...props} customLoader={<div></div>} loader={loader} />
);

export default CustomPageLoader;
